import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'specialtyTypes' as const;

export const specialtyTypesTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, specialtyTypeOptions }) => {
    const ids = getTermsValue('specialty_types')(jsonQuery);

    if (ids === null) {
      return null;
    }

    const optionsById = new Map((specialtyTypeOptions ?? []).map(item => [item.id, item.name]));

    return ids.map(id => ({
      label: optionsById.get(id) ?? `Назначение ${id}`,
      value: createTagValue(ID, id.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const ids = getTermsValue('specialty_types')(jsonQuery);

    if (ids === null) {
      return jsonQuery;
    }

    const next = ids.filter(id => String(id) !== removingTagValue);

    return next.length > 0 ? setTerms('specialty_types')(jsonQuery)(next) : resetTerms(['specialty_types'])(jsonQuery);
  },
};
